import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getWebPartition } from '@/helpers';
import { usePartition } from '@/providers/usePartition';

export const PartitionSync = () => {
  const location = useLocation();
  const { setPartition } = usePartition();

  useLayoutEffect(() => {
    setPartition(getWebPartition(location.pathname));
  }, [location.pathname, setPartition]);

  return null;
};
